var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.Collection = require('./collections/product_reviews');

ProductReviews.Views.Main = require('./views/product_reviews');

ProductReviews.Views.PaginationFooter = require('./views/pagination_footer');

ProductReviews.Model = require('./models/product_review');

ProductReviews.init = function(arg, done) {
  var collection, csrf, dealTitle, dealUrl, dealUuid, displayOptions, helpful, helpfulCollection, model, pageSize, previewReviews, productReviews, reviewCount, reviewable, reviews, rootUrl, source, userReview;
  csrf = arg.csrf, rootUrl = arg.rootUrl, productReviews = arg.productReviews;
  if (!(productReviews != null ? productReviews.dealUuid : void 0)) {
    return done();
  }
  reviewable = productReviews.reviewable, dealUuid = productReviews.dealUuid, dealUrl = productReviews.dealUrl, dealTitle = productReviews.dealTitle, pageSize = productReviews.pageSize, reviewCount = productReviews.reviewCount, displayOptions = productReviews.displayOptions, source = productReviews.source, reviews = productReviews.reviews, helpful = productReviews.helpful, userReview = productReviews.userReview, previewReviews = productReviews.previewReviews;
  collection = new ProductReviews.Collection(reviews, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions,
    pageSize: pageSize
  });
  helpfulCollection = new ProductReviews.Collection(helpful != null ? helpful.reviews : void 0, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions
  });
  model = new ProductReviews.Model(userReview, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions,
    source: source
  });
  return $(function() {
    var main, options, paginationFooter, previewCollection;
    options = {
      rootUrl: rootUrl,
      csrf: csrf,
      reviewable: reviewable,
      dealUuid: dealUuid,
      dealUrl: dealUrl,
      dealTitle: dealTitle,
      collection: collection,
      helpfulCollection: helpfulCollection,
      model: model,
      reviewCount: reviewCount,
      previewCollection: previewCollection,
      displayOptions: displayOptions,
      source: source
    };
    main = new ProductReviews.Views.Main(options);
    if (displayOptions.showReviewsPage) {
      previewCollection = new ProductReviews.Collection(previewReviews, {
        rootUrl: rootUrl,
        csrf: csrf,
        dealUuid: dealUuid,
        displayOptions: displayOptions,
        isPreview: true
      });
      paginationFooter = new ProductReviews.Views.PaginationFooter(options);
      options.el = '#product-reviews-preview';
      options.previewCollection = previewCollection;
      previewCollection.initializePreview(new ProductReviews.Views.Main(options));
    }
    collection.view = main;
    helpfulCollection.view = main;
    model.view = main;
    return done();
  });
};

module.exports = ProductReviews;

//# sourceMappingURL=data:application/json;base64,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
